import React, { useEffect, useState } from "react";
import AppProviders from "../AppProviders";
import Routes from "../Route";
import firebase from "firebase";
import Login from "../../pages/Login";
import Register from "../../pages/Register";
import ForgotPassword from "../../pages/ForgotPassword";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

const App = () => {
  const [isLoading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(firebase.auth().currentUser);

  useEffect(() => {
    firebase.auth().onAuthStateChanged((nextUser) => {
      setLoading(false);
      setCurrentUser(nextUser);
    });
  });

  if (isLoading) {
    return <div>Loading..</div>;
  }

  if (!currentUser) {
    return (
      <Router>
        <Switch>
          <Route path="/forgot-password" exact component={ForgotPassword} />
          <Route path="/register" exact component={Register} />
          <Route path="/" component={Login} />
        </Switch>
      </Router>
    );
  }

  return (
    <AppProviders>
      <Routes />
    </AppProviders>
  );
};

export default App;
